import { createContext } from 'react'

export const PageNavigationContext = createContext({})